import { View } from "react-native";
import React, { useEffect, useRef } from "react";
import { Radio, Text } from "@ui-kitten/components";
import StripePaymentForm, {
  StripeTokenError,
  StripeTokenResponse,
} from "components/StripePaymentForm/StripePaymentForm";
import { useAppSelector } from "hooks/useAppSelector";
import { useMutation } from "@tanstack/react-query";
import { planIdProperty } from "./helpers";
import { createContactFetcher } from "queries/user.queries";
import Button from "components/Button";

const StepFour = ({
  handleTokenReceived,
}: {
  handleTokenReceived: (
    error: StripeTokenError | undefined,
    response?: StripeTokenResponse
  ) => void;
}) => {
  const { selectedCmsPlan } = useAppSelector((state) => state.shopPagePhaseTwo);
  const { isEditingPrimaryUser, primaryUser, selectedPlanPackage } =
    useAppSelector((state) => state.buyFlow);
  const contactSubmitted = useRef(false); // Ref that keeps track of whether contact has been submitted, to prevent multiple submissions

  const { mutateAsync: createContact } = useMutation(createContactFetcher);

  const shouldBill = Number(selectedPlanPackage?.fullPrice) > 0;

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        if (primaryUser.email && contactSubmitted.current === false) {
          contactSubmitted.current = true;
          createContact({
            firstName: primaryUser.firstName,
            lastName: primaryUser.lastName,
            phone: primaryUser.phone,
            email: primaryUser.email,
            source: "SHOP_PAGE_PHASE_TWO",
            planPackageId: selectedCmsPlan![planIdProperty]!,
            buyflowStep: "Payment Information",
          });
        }
      }
    };

    window.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [selectedCmsPlan, primaryUser]);

  return (
    <View className="flex-1">
      {shouldBill && (
        <>
          <Text category="h6">Payment</Text>
          <View className="bg-white rounded-xl my-4 shadow-lg font-semibold text-lg">
            <View className="border-b-2 border-b-stone-200">
              <View className="p-4">
                <Radio checked>Credit Card</Radio>
              </View>
            </View>
            <View className="p-4">
              <StripePaymentForm
                onTokenReceived={handleTokenReceived}
                disabled={isEditingPrimaryUser}
              />
            </View>
          </View>
        </>
      )}
      {!shouldBill && (
        <View className=" font-semibold text-lg">
          <View className="p-4">
            <Button
              onPress={() => handleTokenReceived(undefined)}
              disabled={isEditingPrimaryUser}
            >
              Create My Account
            </Button>
          </View>
        </View>
      )}
    </View>
  );
};

export default StepFour;
